import IntegerBase from './integer-base';

export default class PositiveInteger extends IntegerBase {
  minInt = 0;
}
